module.exports = __webpack_public_path__ + "static/images/containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/nation/nation-cn-sweden.34691c16.png";


//////////////////
// WEBPACK FOOTER
// ./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/nation/nation-cn-sweden.png
// module id = 1124
// module chunks = 16